export const PUSH_NOTIFICATION_PROMPT_EVENT =
  "ilovemacumba:push-notification-prompt-request";

const PUSH_PROMPT_DISMISSED_AT_KEY = "ilovemacumba:push-prompt-dismissed-at";
const PUSH_PROMPT_HOME_SHOWN_PREFIX = "ilovemacumba:push-prompt-home-shown:";
const DISMISS_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;

export type PushNotificationPromptReason = "terreiro_join" | "app_home";

export type PushNotificationPromptRequest = {
  reason: PushNotificationPromptReason;
};

export const requestPushNotificationPrompt = (
  reason: PushNotificationPromptReason,
) => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<PushNotificationPromptRequest>(
      PUSH_NOTIFICATION_PROMPT_EVENT,
      {
        detail: { reason },
      },
    ),
  );
};

export const markPushNotificationPromptDismissed = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(
    PUSH_PROMPT_DISMISSED_AT_KEY,
    String(Date.now()),
  );
};

export const shouldShowPushNotificationPrompt = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  const dismissedAt = window.localStorage.getItem(PUSH_PROMPT_DISMISSED_AT_KEY);
  if (!dismissedAt) {
    return true;
  }

  const dismissedTime = Number(dismissedAt);
  if (!Number.isFinite(dismissedTime)) {
    return true;
  }

  return Date.now() - dismissedTime >= DISMISS_COOLDOWN_MS;
};

export const markHomePushNotificationPromptShown = (userId: string) => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(`${PUSH_PROMPT_HOME_SHOWN_PREFIX}${userId}`, "1");
};

export const hasHomePushNotificationPromptBeenShown = (userId: string) => {
  if (typeof window === "undefined") {
    return true;
  }

  return (
    window.localStorage.getItem(`${PUSH_PROMPT_HOME_SHOWN_PREFIX}${userId}`) ===
    "1"
  );
};
